import Page from 'src/apipages/legacy-libraries/index';

export default Page;
